"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _colors = _interopRequireDefault(require("../theme/colors"));
var _fonts = _interopRequireDefault(require("../theme/fonts"));
var _system = require("@mui/system");
var _i18n = _interopRequireDefault(require("../localization/i18n"));
var _tokens = _interopRequireDefault(require("../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 
 * @param {*} props 
 * @returns 
 */
var SearchBar = function SearchBar(_ref) {
  var onBlur = _ref.onBlur,
    search = _ref.search,
    onChange = _ref.onChange,
    customStyle = _ref.customStyle,
    placeholder = _ref.placeholder,
    value = _ref.value,
    iconColor = _ref.iconColor,
    id = _ref.id,
    testid = _ref.testid;
  var _useState = (0, _react.useState)(value || ""),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var theme = (0, _system.useTheme)();

  /**
   * 
   * @param {*} event 
   */
  var _onChangeWithStop = function _onChangeWithStop(event) {
    event.stopPropagation();
    if (event.key === 'Enter') {
      search(event.target.value);
    }
  };

  /**
   * 
   * @param {*} event 
   */
  var _onChange = function _onChange(event) {
    setQuery(event.target.value);
    onChange && onChange(event);
  };
  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    id: id || testid,
    variant: "outlined",
    value: query,
    label: placeholder || _i18n["default"].t(_tokens["default"].labels.search),
    sx: _objectSpread({
      '& .MuiOutlinedInput-root': {
        "&:hover fieldset": {
          borderColor: theme.palette.custom.textFieldHover
        }
      },
      '& .MuiInputBase-root': {
        fontFamily: '"AvenirLTPro-Book", sans-serif',
        fontWeight: 400,
        color: theme.palette["default"].contrastText,
        // this keeps letter spacing consistent with site before mui5 upgrade
        letterSpacing: "0.14994px"
      }
    }, customStyle),
    InputLabelProps: {
      style: {
        fontFamily: _fonts["default"].type.light,
        paddingRight: "2px",
        color: theme.primary
      }
    },
    onBlur: onBlur,
    onChange: _onChange,
    onKeyDown: _onChangeWithStop,
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    type: "text",
    InputProps: {
      autoComplete: 'off',
      endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        onClick: function onClick() {
          return search(query);
        },
        "aria-label": "Search",
        sx: {
          padding: "12px",
          "&:hover": {
            backgroundColor: _colors["default"].hoverGrey
          },
          color: _colors["default"].black
        }
      }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
        style: {
          color: iconColor || null
        }
      })))
    }
  });
};
SearchBar.propTypes = {
  classes: _propTypes["default"].object
};
var _default = exports["default"] = SearchBar;